import React from 'react';
import { Box, InfoOutlineIcon, Inscription } from '@common-fe/common-fe';

interface Props {
  title?: string;
  text?: string;
}
const InfoBlock: React.FC<Props> = ({ title, text }) => (
  <Box
    background="canvas"
    border={{ color: 'border2', size: 'xsmall' }}
    align="center"
    round="container1Round"
    pad="spacing12"
    style={{ position: 'relative' }}
  >
    <Box
      round="smallRound"
      height="2px"
      background="info"
      width="calc(100% - 24px)"
      style={{ top: '-1px', position: 'absolute' }}
    />
    <Box
      border={{ color: 'infoBorder', size: 'small' }}
      round="container2Round"
      align="center"
      background="infoContainer"
      pad={{ vertical: 'spacing16', horizontal: 'spacing24' }}
    >
      <Box direction="row" align="center">
        <Box margin={{ right: 'spacing8' }} width={{ min: '24px' }}>
          <InfoOutlineIcon color="info" />
        </Box>
        <Inscription color="textBody" weight="bold" lineHeight="20px">
          {title}
        </Inscription>
      </Box>
      <Box margin={{ top: 'spacing8' }}>
        <Inscription color="textBody" lineHeight="20px">
          {text}
        </Inscription>
      </Box>
    </Box>
  </Box>
);

export default InfoBlock;
